'use strict';

import React, { Component, PropTypes } from 'react';

export default class 載入頁面 extends Component {

  render() {
    return (
       <div className='main ui text container'>
           <div className="ui padded compact basic segment">
            <span>載入中，小等一下...</span></div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/GuanKiann/載入頁面/載入頁面.jsx